// extracted by css-extract-rspack-plugin
export default {"codeContainer":"c6Glv","code":"j3w6a"};